// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headingTitle {
  color: #F27400;
  position: absolute;
  font-size: 39px;
  text-align: center;
  font-family: "Gemunu Libre ExtraBold", sans-serif;
  width: 330px;
  height: 64px;
  left: 25px;
  top: 25px;
  cursor: pointer;
}

.headingDiv {
  display: flex;
  flex-direction: row;
  z-index: 1;
  text-align: center;
  background-color: #FDFDFD;
  height: 107px;
  width: 100%;
  position: fixed;
}

.navLinks {
  display: flex;
  flex-direction: row;
  position: absolute;
  text-align: center;
  left: 1015px;
  height: 48.61px;
  top: 32px;
}

.linkText {
  color: black;
  font-size: 22px;
  font-weight: 600;
  margin: -9px 30px;
}
.linkText:hover {
  color: #F27400;
  text-decoration: none;
  cursor: pointer;
}

.quoteText {
  position: absolute;
  border: 1.5px solid black;
  top: -4px;
  left: -175px;
  padding: 5px 20px;
  padding-top: 2px;
}
.quoteText:hover {
  border: 1.5px solid #F27400;
}

.ourWorkTexts {
  display: flex;
  flex-direction: row;
}

.ourWork {
  margin: 0px 3px;
}

.phoneNumber {
  margin-left: 10px;
  margin-top: 20px;
  font-size: 22px;
  font-weight: 700;
}

.phoneNumberDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  right: 24px;
  top: 45px;
}

.phone {
  align-self: center;
  font-size: 20px;
  color: #F27400;
  margin-bottom: -14px;
}

@media (max-width: 425px) {
  .navLinks {
    display: flex;
    flex-direction: row;
    position: relative;
    text-align: center;
    left: 0px;
    height: 48.61px;
    top: 32px;
  }

  .headingDiv {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 14%;
  }

  .headingTitle {
    position: relative;
    left: 0px;
  }

  .phoneNumberDiv {
    position: relative;
    top: 17px;
  }

  .quoteText {
    position: relative;
    left: 0px;
    height: 39px;
  }

  .linkText {
    margin: -7px 41px;
  }
}`, "",{"version":3,"sources":["webpack://./src/CSS/Nav.scss","webpack://./src/CSS/_variables.scss"],"names":[],"mappings":"AAMA;EACI,cCPY;EDQZ,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iDAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AALJ;;AAQA;EAjBI,aAAA;EACA,mBAAA;EAkBA,UAAA;EACA,kBAAA;EACA,yBCrBQ;EDsBR,aAAA;EACA,WAAA;EACA,eAAA;AAJJ;;AAOA;EA3BI,aAAA;EACA,mBAAA;EA4BA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;AAHJ;;AAMA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAHJ;AAII;EACI,cC5CQ;ED6CR,qBAAA;EACA,eAAA;AAFR;;AAOA;EACI,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;AAKI;EACI,2BAAA;AAHR;;AAOA;EACI,aAAA;EACA,mBAAA;AAJJ;;AAMA;EACI,eAAA;AAHJ;;AAMA;EACG,iBAAA;EACA,gBAAA;EACC,eAAA;EACA,gBAAA;AAHJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,eAAA;EACA,cC3FY;ED4FZ,oBAAA;AAJJ;;AAQA;EACI;IA/FA,aAAA;IACA,mBAAA;IAgGI,kBAAA;IACA,kBAAA;IACA,SAAA;IACA,eAAA;IACA,SAAA;EAJN;;EAME;IACI,WAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,WAAA;EAHN;;EAKE;IACI,kBAAA;IACA,SAAA;EAFN;;EAIE;IACI,kBAAA;IACA,SAAA;EADN;;EAIE;IACI,kBAAA;IACA,SAAA;IACA,YAAA;EADN;;EAGE;IACI,iBAAA;EAAN;AACF","sourcesContent":["@import \"./variables\";\n@mixin flexRow {\n    display: flex;\n    flex-direction: row;\n}\n\n.headingTitle{\n    color: $primaryOrange;\n    position: absolute;\n    font-size: 39px;\n    text-align: center;\n    font-family: 'Gemunu Libre ExtraBold', sans-serif;\n    width: 330px;\n    height: 64px;\n    left: 25px;\n    top: 25px;\n    cursor: pointer;\n}\n\n.headingDiv{\n    @include flexRow();\n    z-index:1;\n    text-align:center;\n    background-color:$baseWhite;\n    height: 107px;\n    width:100%;\n    position: fixed;\n}\n\n.navLinks{\n    @include flexRow();\n    position: absolute;\n    text-align: center;\n    left: 1015px;\n    height: 48.61px;\n    top: 32px;\n}\n\n.linkText{\n    color: black;\n    font-size: 22px;\n    font-weight: 600;\n    margin: -9px 30px;\n    &:hover{\n        color: $primaryOrange;\n        text-decoration: none;\n        cursor: pointer;  \n\n    }\n}\n\n.quoteText{\n    position: absolute;\n    border: 1.5px solid black;\n    top:-4px;\n    left:-175px;\n    padding: 5px 20px;\n    padding-top: 2px;\n    &:hover{\n        border: 1.5px solid $primaryOrange;   \n    }\n}\n\n.ourWorkTexts{\n    display: flex;\n    flex-direction: row;\n}\n.ourWork{\n    margin: 0px 3px;\n}\n\n.phoneNumber{ \n   margin-left: 10px;\n   margin-top: 20px;\n    font-size:22px;\n    font-weight: 700;\n    \n}\n\n.phoneNumberDiv{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    position: absolute;\n    right: 24px;\n    top: 45px;\n}\n\n.phone{\n    align-self: center;\n    font-size: 20px;\n    color: $primaryOrange;\n    margin-bottom: -14px;\n\n}\n\n@media (max-width: 425px){\n    .navLinks{\n        @include flexRow();\n        position: relative;\n        text-align: center;\n        left: 0px;\n        height: 48.61px;\n        top: 32px;\n    }\n    .headingDiv{\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        height: 14%;\n    }\n    .headingTitle{\n        position: relative;\n        left: 0px;\n    }\n    .phoneNumberDiv{\n        position: relative;\n        top: 17px;\n    }\n\n    .quoteText{\n        position: relative;\n        left:0px;\n        height: 39px;\n    }\n    .linkText{\n        margin: -7px 41px;\n    }\n}\n","$primaryOrange: #F27400;\n$secondaryBlue: #111E4B;\n$baseWhite: #FDFDFD;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
